import httpManager from "../../shared/utils/httpManager";

export async function createTemporalUser(user) {
  const body = user;
  const options = { isPublic: true };
  const response = await httpManager.post("/customers/temporal-user/", body, options);
  return response.data;
}
